import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {store} from './redux';
import {Provider} from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { ApolloProvider } from '@apollo/client';

import { client } from './client'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <ApolloProvider client={client}>
      <App />
      </ApolloProvider>
    </Provider>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
